import { useEffect, useRef, useState } from "react";
import _debounce from "lodash/debounce";

export function useHorizontalScrollControl(
  scrollDistance: number,
  dependencies: unknown[] = []
) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

      setShowLeft(scrollLeft > 0);

      setShowRight(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    checkScroll();

    const handleScroll = _debounce(checkScroll, 100);

    el?.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      el?.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      handleScroll.cancel();
    };
  }, [...dependencies]);

  const scroll = (direction: "left" | "right") => {
    scrollRef.current?.scrollBy({
      left: direction === "left" ? -scrollDistance : scrollDistance,
      behavior: "smooth",
    });
  };

  return {
    scrollRef,
    showLeft,
    showRight,
    scroll,
  };
}
